'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';

interface ProgramCompleteProps {
  userId: string;
  durationWeeks: number;
}

/**
 * Re-exported from lib/programDuration so existing importers keep working.
 * The implementation moved out of this component file so it could be tested —
 * vitest's node environment cannot import a .tsx.
 */
export { getProgramDurationWeeks } from '@/lib/programDuration';

export default function ProgramComplete({ userId, durationWeeks }: ProgramCompleteProps) {
  const router = useRouter();
  return (
    <div className="operator-panel border-2 border-operator-gold bg-gradient-to-r from-operator-gold/20 to-operator-gunmetal">
      <div className="text-center py-6">
        <div className="text-4xl mb-4">🎖</div>
        <h2 className="text-2xl font-heading font-bold uppercase text-operator-gold mb-2">
          Mission Complete
        </h2>
        <p className="text-gray-300 mb-6">
          Congratulations! You&apos;ve completed your {durationWeeks}-week program.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link
            href="/programs/change"
            className="px-4 py-2 bg-operator-gold text-operator-void font-bold uppercase text-sm rounded hover:bg-operator-gold-light transition"
          >
            Choose New Program
          </Link>
          <button
            onClick={async () => {
              const { resetProgramProgress } = await import('@/lib/dayTracking');
              await resetProgramProgress(userId);
              router.refresh();
            }}
            className="px-4 py-2 border border-operator-steel text-gray-300 font-bold uppercase text-sm rounded hover:border-operator-gold hover:text-white transition"
          >
            Repeat Program
          </button>
          <Link
            href="/workouts/custom"
            className="px-4 py-2 border border-operator-steel text-gray-300 font-bold uppercase text-sm rounded hover:border-operator-gold hover:text-white transition"
          >
            Go Custom
          </Link>
        </div>
      </div>
    </div>
  );
}
